import React from "react";
import { Helmet } from "react-helmet-async";
import { Link, useHistory } from "react-router-dom";
import { candidateExplainerData as data } from "../data/candidate-explainer.data";
import { useRedirectUrl } from "../hooks/useRedirectUrl";
import styles from "./candidate-explainer.module.scss";
import "./candidate-explainer.scss";
import img1 from "../assets/images/si/howto-1.png";
import img2 from "../assets/images/si/howto-2.png";
import img3 from "../assets/images/si/howto-3.png";
import img4 from "../assets/images/si/howto-4.png";
import img5 from "../assets/images/si/howto-5.png";
import img6 from "../assets/images/si/howto-6.png";
import img7 from "../assets/images/si/howto-7.png";

export function SiSupportHowTo() {
  const redirect = useRedirectUrl("/second-interview-support");
  const history = useHistory();

  return (
    <div className={`${styles["candidateExplainer"]} candidate-container`}>
      <Helmet>
        <title>Sapia | Candidate Explainer</title>
        <meta http-equiv="refresh" content="0; url=https://sapia.ai/second-interview-support/how-to-complete-your-interview/" />
      </Helmet>

      {/* <div className={styles["explainerBanner"]}>
        <ul className={styles["landingBreadcrumbs"]}>
          {data?.header_section?.breadcrums.map((b, i) => {
            switch (i) {
              case 0:
                return (
                  <li className={styles["candidateBtn"]} key={i}>
                    <a href={redirect}>{b.label}</a>
                  </li>
                );
              default:
                return b.link ? (
                  <li key={i}>
                    <Link to="/second-interview-support">{b.label}</Link>
                  </li>
                ) : (
                  <span>{b.label}</span>
                );
            }
          })}
        </ul>

        <div className={styles["tableOfContent"]}>
          <h3>How to complete your interview</h3>
          <ul>
            <li>
              <a href="#1">Can I see the questions in advance?</a>
            </li>
            <li>
              <a href="#2">How should I answer the interview questions?</a>
            </li>
            <li>
              <a href="#3">How many attempts do I get?</a>
            </li>
            <li>
              <a href="#4">Can I take breaks during the interview?</a>
            </li>
            <li>
              <a href="#5">
                Can I start/stop recording or re-answer when I want?
              </a>
            </li>
            <li>
              <a href="#6">How do I know I’m being recorded?</a>
            </li>
            <li>
              <a href="#7">How do I know if my response was saved?</a>
            </li>
          </ul>
        </div>

        <div className={styles["siQA"]}>
          <div className={styles["siQAItem"]} id="1">
            <h4>Can I see the questions in advance?</h4>
            <p>
              You’ll be sent a link to begin the interview to your email
              address. This will come from notifications@predictivehire.com.
              Simply click on the link in the email to begin your video
              interview.{" "}
            </p>
            <img
              src={img1}
              alt=""
              style={{ width: "70%", display: "block", margin: "0 auto" }}
            />
          </div>

          <div className={styles["siQAItem"]} id="2">
            <h4>How should I answer the interview questions?</h4>
            <p>
              Answer as though you were speaking to an interviewer. The best way
              to answer behavioural based questions is to use the STAR format:
              <ul >
                <li>
                  Briefly describe the Situation and the Task you were given
                </li>
                <li>
                  Explain the Action/s that you took in a moderate amount of
                  detail
                </li>
                <li>
                  Provide a summary and the Result of the situation you are
                  describing
                </li>
              </ul>
            </p>

            <p>
              There are lots of resources available online to further support
              you with any interview preparation you’d like to undertake.
            </p>
          </div>

          <div className={styles["siQAItem"]} id="3">
            <h4>How many attempts do I get?</h4>
            <p>
              Before you begin the questions you’ll find a test question where
              you can check your microphone and camera are working. If they’re
              not working,{" "}
              <a
                href=""
                onClick={() => {
                  history.push("/second-interview-support-issues");
                }}
              >
                check our troubleshooting section.
              </a>
            </p>
            <p>
              You’ll get three attempts to record each question. Click the white
              Record button to begin. Once you have finished, you can play it
              back to check you’re happy with the response. If not, click the
              Retry button located next to the record button, and try again.
              Once you’re happy with your response, click ‘Save’.
            </p>
            <img src={img2} alt="" style={{ width: "70%" }} />
          </div>

          <div className={styles["siQAItem"]} id="4">
            <h4>Can I take breaks during the interview?</h4>
            <p>
              Yes, you can take as many breaks as you want. Your interview is
              not timed, and provided you press Save at the end of each response
              your answers will be saved. You can answer a question, take a
              break, and continue without losing your recordings. You can also
              change a saved answer if you have enough retakes available too.
            </p>
          </div>

          <div className={styles["siQAItem"]} id="5">
            <h4>Can I start/stop recording or re-answer when I want?</h4>
            <p>
              Yes. You can stop the recording at any point, and can re-record up
              to 3 times. However, when you press Retry you will permanently
              delete the answer that has already been recorded.
            </p>
            <img src={img3} alt="" style={{ width: "70%" }} />
            <p>
              If you want to amend a recording but you have already pressed
              Save, click the Retry icon next to the video to re-record it with
              any attempts you have left.
            </p>
            <img src={img4} alt="" style={{ width: "70%" }} />
          </div>

          <div className={styles["siQAItem"]} id="6">
            <h4>How do I know I’m being recorded?</h4>
            <p>
              Once you have begun, the Record button will change to Stop. You
              will also see REC next to a red button in the upper right hand
              corner of your video, and a timer in the bottom centre, as shown
              below. While you are recording the Play, Save and Retry buttons
              will be disabled.
            </p>
            <img src={img5} alt="" style={{ width: "70%" }} />
          </div>

          <div className={styles["siQAItem"]} id="7">
            <h4>How do I know if my response was saved?</h4>
            <p>
              Your response will only be saved if you have pressed the Save
              button after recording it. If you are mid-way through a recording
              and the browser window is closed your answer will not be saved.
              The time taken to upload your response will depend on your
              internet connection, but you will see the status in the window.
            </p>
            <p>This is an example of a video that is still uploading:</p>
            <img src={img6} alt="" style={{ width: "70%" }} />
            <p>This is an example of a video that has not uploaded:</p>
            <img src={img7} alt="" style={{ width: "70%" }} />
          </div>
        </div>
      </div>

      <div className="interview-support-section explainer-padding">
        <div className="container">
          <div className="text-center">
            <h3 className="blue-title">{data.contact_section.section_title}</h3>
            <button
              type="button"
              className="btn-help"
              style={{ cursor: "pointer" }}
            >
              {data.contact_section.button_label}
            </button>
            <p>
              <a
                href={data.contact_section.privacy_button_link}
                className="black-link"
              >
                {data.contact_section.privacy_button_label}
              </a>
            </p>
            <p>
              <a href="/terms-of-service" className="black-link">
                Read our Terms of Service here {">"}
              </a>
            </p>
          </div>
        </div>
      </div> */}
    </div>
  );
}
